import request from '@/utils/request'

/**
 * @describe 分页查看纸质合格证
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param entName
 * @param entProductId 企业产品id
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageCertificatePaper(query) {
  return request({
    url: 'cert/pageCertificatePaper.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 获取一个纸质合格证
 * @param certificatePaperId
 */
export function getOneCertificatePaper(query) {
  return request({
    url: 'cert/getOneCertificatePaper.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 新增一个纸质合格证
 * @param dataUrl
 * @param entId
 * @param entProductId
 * @param printCount
 * @param printTime
 * @param num
 * @param unitId
 * @param signature
 */
export function saveCertificatePaper(query) {
  return request({
    url: 'cert/saveCertificatePaper.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 修改一个纸质合格证
 * @param certificatePaperId
 * @param 同上
 */
export function editCertificatePaper(query) {
  return request({
    url: 'cert/editCertificatePaper.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 删除一个纸质合格证
 * @param certificatePaperId
 */
export function delCertificatePaper(query) {
  return request({
    url: 'cert/delCertificatePaper.do',
    method: 'POST',
    data: query
  })
}
